import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@apollo/client';
import { latestCreatorsDocument } from '@social-garden/api/documents/creator.ts';
import { Card, Container, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-thin-svg-icons/faUsers';
import PageTitle from '@/components/PageTitle.tsx';
import CreatorListItem from '@/components/CreatorListItem.tsx';
import ButtonLink from '@/components/ButtonLink.tsx';

export const Route = createFileRoute('/_manager/_app/creators/')({
  component: Creators,
});

function Creators() {
  const { t } = useTranslation(['manager']);
  const {
    data: { latestCreators },
  } = useSuspenseQuery(latestCreatorsDocument);

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid container size={12} spacing={2}>
          <Grid size={12}>
            <PageTitle>{t('manager:navigation.creators')}</PageTitle>
          </Grid>
          <Grid size={12}>
            <Typography variant="h5">
              {t('manager:creators.subtitle')}
            </Typography>
          </Grid>
        </Grid>
        <Grid container size={12}>
          {latestCreators.map((creator) => (
            <Grid key={creator.id} size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
              <CreatorListItem variant="outlined" data={creator} />
            </Grid>
          ))}
        </Grid>
        <Grid size={12}>
          <Card variant="outlined">
            <Stack
              py={8}
              px={4}
              spacing={4}
              alignItems="center"
              justifyContent="center">
              <FontAwesomeIcon icon={faUsers} size="6x" />
              <Typography fontSize={32} fontWeight={300} textAlign="center">
                {t('manager:creators.footer.header')}
              </Typography>
              <ButtonLink variant="contained" size="large" to="/campaigns">
                {t('manager:creators.footer.button')}
              </ButtonLink>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
